import { useAxios } from "./api";

const basePath = "/api/v1/user";
const endpoint = {
  getUserByIdentifier: { path: `${basePath}/{{identifier}}`, method: "GET" },
};

export const useQueryUser = () => {
  let [state, fetch] = useAxios(
    {
      method: endpoint.getUserByIdentifier.method,
    },
    { manual: true }
  );
  return [
    state,
    (id) => {
      return fetch({
        url: endpoint.getUserByIdentifier.path.replace("{{identifier}}", id),
      });
    },
  ];
};
